import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CarouselSlider from "./CarouselSlider";
import LegacySlider from "./LegacySlider";

export default ({ data }) => {
  const theme = useTheme();
  const disableGutters = useMediaQuery(theme.breakpoints.down("sm"));

  if (disableGutters) {
    return <CarouselSlider data={data} />;
  } else {
    return <LegacySlider data={data} />;
  }
};
